module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-image-preview"
  }, [_c('label', {
    staticClass: "file-select"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.imgSrc),
      expression: "!imgSrc"
    }],
    staticClass: "select-button"
  }, [_vm._v("\n      ADICIONAR FOTO\n    ")]), _vm._v(" "), (_vm.isLoading && _vm.imgSrc) ? _c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgSrc),
      expression: "imgSrc"
    }],
    attrs: {
      "src": _vm.imgSrc
    },
    on: {
      "load": _vm.revokeURL
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    domProps: {
      "value": _vm.inputfile
    },
    on: {
      "change": _vm.handleFileChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be88b618","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CameraImageSelect.vue
// module id = 842
// module chunks = 1